export default {
    title: "shoph5",
    baseUrl: {
        dev: "http://hsshop-server-t.69dp.cn/api/",//开发的时候后台接口的地址
        pro: "http://hsshop-server-t.69dp.cn/api/"//上线产品发布之后，后台接口的地址
    }
}

// 正式 http://hsshop-server.69dp.cn/api/
// 测试 http://hsshop-server-t.69dp.cn/api